// Keep the service and the declared parcel category compatible in both forms.
const SERVICES = new Set(["standard", "express", "van"]);
const SIZES = new Set(["small", "medium", "large", "xl"]);

export function normalizeParcelSelection(service, size) {
  const delivery_type = SERVICES.has(service) ? service : "standard";
  const package_size = SIZES.has(size) ? size : "medium";
  return delivery_type === "van" || package_size === "xl"
    ? { delivery_type: "van", package_size: "xl" }
    : { delivery_type, package_size };
}

export function selectDeliveryService(current, service) {
  if (!SERVICES.has(service)) return current;
  return {
    delivery_type: service,
    package_size: service === "van" ? "xl" : current.package_size === "xl" ? "medium" : current.package_size,
  };
}

export function selectParcelCategory(current, size) {
  if (!SIZES.has(size)) return current;
  return {
    delivery_type: size === "xl" ? "van" : current.delivery_type === "van" ? "standard" : current.delivery_type,
    package_size: size,
  };
}
